import { useAuthentication } from '@psyomics/ui-common';
import { PatientAppBar } from '@psyomics/ui-components';
import { Outlet } from 'react-router-dom';

import { usePatientAppBarContext } from '../../contexts/patient-app-bar';

function SecureLayout() {
  const { isAuthenticated } = useAuthentication();
  const { showUrgentHelp, setShowUrgentHelp } = usePatientAppBarContext();

  if (!isAuthenticated) return null;

  return (
    <div className="flex h-full flex-col">
      <header>
        <PatientAppBar
          iconHref="/account"
          logoHref="/"
          onShowUrgentHelpDialogChange={setShowUrgentHelp}
          showUrgentHelpDialog={showUrgentHelp}
        />
      </header>
      <main className="flex min-h-0 flex-1 flex-col">
        <Outlet />
      </main>
    </div>
  );
}

export { SecureLayout };
